import { SessionLike } from "./can";

type BranchSession = SessionLike & {
  branchId?: number | null;
};

/**
 * El usuario solo puede operar su sucursal efectiva.
 * No usa el nombre del rol: grantsAll ve todas; un branchId fijo no.
 */
export function isBranchConstrained(
  session: BranchSession | null | undefined,
): boolean {
  return (
    session?.grantsAll !== true &&
    typeof session?.branchId === "number"
  );
}
